// Shared avatar list and helper functions for reuse across the app
export const SAMPLE_AVATARS =  [
    {
        "avatar_id": "fd568a2177a042ac9f3167aa81c6a252",
        "avatar_name": "Ethan",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/ethan.webp",
        "preview_video_url": "https://player.vimeo.com/video/1154565690?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "3798c440fef04cb8888303cecdd68e9f",
        "template_id": "6ddcccd6daa547a9bb91033234f5ed57",
    },
    {
        "avatar_id": "9f8e1ee31cfd4f6fbdf911ace5d57aae",
        "avatar_name": "Sophie",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/Sophie.webp",
        "preview_video_url": "https://player.vimeo.com/video/1154565645?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "c15359c40b3243fbaeaf32bf5907096d"
    },
    {
        "avatar_id": "faeef5337c084546a644aa4686f41e59",
        "avatar_name": "Emily",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/Emily.webp",
        "preview_video_url": "https://player.vimeo.com/video/1154565572?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "b043767fe25f4964a0df8d69b683314f",
        "template_id": "7d3c5f898971437b8f5db12dcfdc43dd",
    },
    {
        "avatar_id": "7edf53917e2e464a8e002c02b6775ed3",
        "avatar_name": "Malik",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/Malik.webp",
        "preview_video_url": "https://player.vimeo.com/video/1154565538?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "2c276d3d6cf742ed9f10a05d1461264b"
    },
    {
        "avatar_id": "5fb45e05d70842e7a57585838f71a13f",
        "avatar_name": "Isabella",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/Isabella.webp",
        "preview_video_url": "https://player.vimeo.com/video/1154565492?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "bf47a4ba76c44d54bf51b0ab0f8793ed"
    },
    {
        "avatar_id": "e36ea5390030419f9c6c47c1d3637ac8",
        "avatar_name": "Michael",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/Michael.webp",
        "preview_video_url": "https://player.vimeo.com/video/1154565426?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "f7c8fb540c7443428012acba725cf0b2"
    },
    {
        "avatar_id": "18de995523574205a0f033413be15e12",
        "avatar_name": "Sophie",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/Sophie-2.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368512?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "18de995523574205a0f033413be15e12",
        "template_id": "46aae4add80c4cffaf1e8d20fbd22ca2",
    },
    {
        "avatar_id": "6ce10d021f694baf894561435f2abf92",
        "avatar_name": "Marcus",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/Marcus.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368551?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "6ce10d021f694baf894561435f2abf92",
        "template_id": "647853bbf333434eaa698af77097dd1c",
    },
    {
        "avatar_id": "e7aad0e0ff83403085e245e5bc30bb8a",
        "avatar_name": "Elena",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/elena.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368610?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "65ff98ef05a04f36b57e2bf7baf8eb00",
        "template_id": "4ce31bd3079046488536e318b4be28ac",
    },
    {
        "avatar_id": "947e24644ff1486e88c60133c85540de",
        "avatar_name": "David",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/David.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368649?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "947e24644ff1486e88c60133c85540de",
        "template_id": "df42d495bdd040b888eac2c5d698b1a9",
    },
    {
        "avatar_id": "b616981645444bbda0b3f16445bfa603",
        "avatar_name": "Miguel",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/Miguel.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368331?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "b616981645444bbda0b3f16445bfa603",
        "template_id": "eff960e8daf14183a03bb8bbbd44e76a",
    },
    {
        "avatar_id": "d288b6f628854023a891b4e4eac8d9f3",
        "avatar_name": "Aisha",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/Aisha.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368389?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "d288b6f628854023a891b4e4eac8d9f3",
        "template_id": "c48b67294dd44773ab68d662f03473bc",
    },
    {
        "avatar_id": "a17d510823fd4e22a6c52f4ff2a48639",
        "avatar_name": "Kenji",
        "gender": "Male",
        "preview_image_url": "/images/avatar-list/Kenji.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368445?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "a17d510823fd4e22a6c52f4ff2a48639",
        "template_id": "44a7db3023cf440aa95818cd787ebf02",
    },
    {
        "avatar_id": "7fd5abd0512f46f68d7c7c2bcad93bbb",
        "avatar_name": "Priya",
        "gender": "Female",
        "preview_image_url": "/images/avatar-list/Priya.webp",
        "preview_video_url": "https://player.vimeo.com/video/1156368483?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
        "premium": false,
        "type": null,
        "tags": null,
        "default_voice_id": null,
        "group_id": "7fd5abd0512f46f68d7c7c2bcad93bbb",
        "template_id": "7c235aa8785443f18295373bb17d0234",
    },
];

export function getAvatarPreviewUrl(avatarObj) {
  if (!avatarObj) return null;
  return (
    avatarObj.preview_video_url ||
    avatarObj.preview_url ||
    avatarObj.video_url ||
    avatarObj.sample_url ||
    avatarObj.preview ||
    avatarObj.url ||
    null
  );
}

export function getAvatarImageUrl(avatarObj) {
  if (!avatarObj) return null;
  return (
    avatarObj.thumbnail_url ||
    avatarObj.thumbnail ||
    avatarObj.image_url ||
    avatarObj.avatar_image_url ||
    avatarObj.preview_image_url ||
    null
  );
}

export function getAvatars() {
  return SAMPLE_AVATARS.slice();
}

export default {
  SAMPLE_AVATARS,
  getAvatarPreviewUrl,
  getAvatarImageUrl,
  getAvatars,
};
